// extracted by mini-css-extract-plugin
export default {"totalTitle":"render-table-cell_totalTitle__8fdOi","placeHolderShimmer":"render-table-cell_placeHolderShimmer__W1cxQ"};